const o=16,t=8,p="top";export{t as TOOLTIP_ARROW_HEIGHT,o as TOOLTIP_ARROW_WIDTH,p as TOOLTIP_DEFAULT_POSITION};
//# sourceMappingURL=constants.js.map
